import * as React from "react";
import { Create, SimpleForm, AutocompleteInput, TextInput, PasswordInput, ArrayInput, SimpleFormIterator, ReferenceArrayInput, SelectArrayInput } from 'react-admin';

export const RuleCreate = props => (
  <Create title="New External" {...props}>
    <SimpleForm>
      <TextInput source="title" required />
      <TextInput source="field_label" required />
      <ArrayInput source="entries_value" label="Values">
        <SimpleFormIterator>
          <TextInput label="Header value" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);

